module.exports = __webpack_public_path__ + "media/images/application/template/queens-trade-ba6b3fc4af78a6684426979c701420d4.png";